import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/compare-depression-treatments")({
  beforeLoad: () => {
    throw redirect({ to: "/compare-treatments" });
  },
});
